export const collectionFromResponse = response => {
  const payload = response?.data?.payload || response?.data || {};

  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.data)) return payload.data;
  if (Array.isArray(payload.results)) return payload.results;

  return [];
};

export const recordFromResponse = response => {
  const payload = response?.data?.payload || response?.data || {};
  return payload.item || payload.data || payload;
};

export const metaFromResponse = response => response?.data?.meta || {};

export const errorMessage = (
  error,
  fallback = 'Não foi possível concluir esta ação agora.'
) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.response?.data?.errors?.[0] ||
  error?.message ||
  fallback;

export const labelForStatus = status => {
  const labels = {
    active: 'Publicado',
    published: 'Publicado',
    draft: 'Rascunho',
    pending: 'Em revisão',
    ready_to_publish: 'Pronto para publicar',
    paused: 'Pausado',
    inactive: 'Despublicado',
    unpublished: 'Despublicado',
    archived: 'Arquivado',
    failed: 'Precisa de atenção',
    blocked: 'Precisa de atenção',
  };

  return labels[String(status || '').toLowerCase()] || 'Em preparação';
};

export const labelForPublicationType = type => {
  const labels = {
    STANDARD: 'Padrão',
    PREMIERE_1: 'Exclusivo',
    PREMIERE_2: 'Superior',
    EXCLUSIVE: 'Exclusivo',
    SUPERIOR: 'Superior',
  };

  return labels[String(type || '').toUpperCase()] || 'Padrão';
};

export const statusClass = status => {
  const normalizedStatus = String(status || '').toLowerCase();
  if (['active', 'published'].includes(normalizedStatus)) {
    return 'bg-emerald-50 text-emerald-700';
  }
  if (['pending', 'paused', 'ready_to_publish'].includes(normalizedStatus)) {
    return 'bg-amber-50 text-amber-800';
  }
  if (['failed', 'blocked'].includes(normalizedStatus)) {
    return 'bg-rose-50 text-rose-700';
  }
  return 'bg-slate-100 text-slate-600';
};

export const formatCurrency = value => {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return 'Valor a combinar';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  }).format(amount);
};

export const listingImageUrl = listing =>
  listing?.cover_image_url ||
  listing?.coverImage?.imageUrl ||
  listing?.cover_image?.url ||
  listing?.images?.[0]?.url ||
  listing?.images?.[0]?.image_url ||
  listing?.images?.[0]?.resized_url ||
  listing?.media?.[0]?.url ||
  '';

export const listingAddress = listing => {
  const address = listing?.address || {};
  return [
    address.neighborhood || listing?.neighborhood,
    address.city || listing?.city,
    address.state || listing?.state,
  ]
    .filter(Boolean)
    .join(' · ');
};

export const formatDateTime = value => {
  if (!value) return 'Ainda não sincronizado';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Ainda não sincronizado';

  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
};
